import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthenticationService } from './authentication.service'

export const CanActivateNoRoles: CanActivateFn = (
   route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
   const router = inject(Router)
   return inject(AuthenticationService)
      .hasLicence()
      .then((hasLicence) => {
         return !hasLicence ? true : router.createUrlTree(['/'])
      })
}

export const CanActivateHasRoles: CanActivateFn = (
   route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
   const router = inject(Router)
   return inject(AuthenticationService)
      .hasLicence()
      .then((hasLicence) => {
         return hasLicence ? true : router.createUrlTree(['/access-denied'])
      })
}
